import ReactAudioPlayer from 'react-audio-player';
import { Eye } from 'react-feather';
import { UncontrolledTooltip } from 'reactstrap';

export const columns = ({ toggleSidebar }) => [
  {
    name: 'EPISODIO',
    minWidth: '200px',
    center: true,
    selector: (row) => row.episode,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.episode}
      </span>
    )
  },
  {
    name: 'AUDIO',
    minWidth: '250px',
    selector: (row) => row.audio,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        <ReactAudioPlayer src={row.audio} controls />
      </span>
    )
  },
  {
    name: 'TOTAL',
    minWidth: '100px',
    selector: (row) => row.total,
    cell: (row) => (
      <span className="text-capitalize" style={{ padding: '10px' }}>
        {row.total}
      </span>
    )
  },
  {
    name: 'ACCIONES',
    minWidth: '100px',
    center: true,
    cell: (row) => (
      <div className="column-action">
        <Eye
          size={17}
          id={`view-${row._id}`}
          className="cursor-pointer"
          onClick={() => toggleSidebar(row)}
        />
        <UncontrolledTooltip placement="top" target={`view-${row._id}`}>
          Ver Detalle
        </UncontrolledTooltip>
      </div>
    )
  }
];
